module.exports = __webpack_public_path__ + "static/media/ope_seija_683x853.4dbd6740.jpg";